export let ApiSetting = {
  DEFAULT_HOST: `${import.meta.env.VITE_API_HOST}`,
  DEFAULT_BASE_PATH: "/api/v1",
};
